export default function HCPMachines() {
  return (
    <div>
      <h1>Máquinas HCP</h1>
      <p>Gerenciamento de produção de máquinas do HCP.</p>
    </div>
  );
}
